import approvedIcon from "../../../assets/icons/check-circle.png";
import reprovedIcon from "../../../assets/icons/times-circle.png";

import styles from "./CheckCard.module.css";

function CheckCard({ title, checks }) {
	return (
		<div className={styles.card}>
			<div className={styles.title}>{title}</div>
			<div className={styles.checksContainer}>
				{checks.map(({ title:label, check }, i) => (
					<div className={styles.checkContainer}>
						<div className={styles.label}>{label}</div>
						<img
							src={check ? approvedIcon : reprovedIcon}
                            className={check ? styles.checkIcon : [styles.icon, styles.disabled].join(" ")}
							alt={check ? "checked" : "not checked"}
						/>
					</div>
				))}
			</div>
		</div>
	);
}

export default CheckCard;
